export default "__VITE_ASSET__w1dfv67R__"